"use client";

import { motion, useReducedMotion } from "framer-motion";
import { HiChevronDown } from "react-icons/hi2";
import { useScrollContext } from "@/components/motion/SmoothScrollProvider";

interface HeroScrollIndicatorProps {
  targetId?: string;
}

export function HeroScrollIndicator({
  targetId = "programs",
}: HeroScrollIndicatorProps) {
  const reduced = useReducedMotion();
  const { scrollToElement } = useScrollContext();

  const handleClick = () => {
    scrollToElement(`#${targetId}`, { offset: 0 });
  };

  return (
    <motion.button
      type="button"
      onClick={handleClick}
      aria-label="Scroll to programs section"
      className="absolute bottom-4 left-1/2 z-20 hidden -translate-x-1/2 flex-col items-center gap-1.5 text-white/60 transition-colors hover:text-white/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/40 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent md:flex sm:bottom-5"
      initial={reduced ? false : { opacity: 0, y: 8 }}
      animate={{ opacity: 0.6, y: 0 }}
      transition={{ duration: 0.6, delay: 1.1, ease: [0.22, 1, 0.36, 1] }}
    >
      <span className="hidden text-[10px] font-medium uppercase tracking-[0.2em] sm:block">
        Scroll
      </span>
      <motion.span
        animate={reduced ? undefined : { y: [0, 6, 0] }}
        transition={
          reduced
            ? undefined
            : { duration: 1.8, repeat: Infinity, ease: "easeInOut" }
        }
        className="inline-flex"
        aria-hidden
      >
        <HiChevronDown className="h-5 w-5 sm:h-6 sm:w-6" />
      </motion.span>
    </motion.button>
  );
}
